import React from 'react'

import { Select, MenuItem, FormControl, InputLabel, FormHelperText } from '@mui/material'

export default function SelectField({ id, label, options, handleChange, value, required = true, isValid = true }) {

    const defaultValue = (options, value) => {
        const selectedOption = options.find(option => option.value === value)
        return selectedOption ? selectedOption.value : ""
    }
    
    const onChange = (event) => {
        handleChange({ value: event.target.value })
    }

    return (<FormControl fullWidth>
        <InputLabel id={`${label}-label`}>{label}</InputLabel>
        <Select 
            fullWidth
            id={id}
            label={label}
            value={defaultValue(options, value) || null}
            onChange={onChange}
            name={id}
            required={required}
            error={!isValid}
            sx={{ marginBottom: 2}}
        >
            {
                options.map(option => {
                    return (<MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)
                })
            }
        </Select>
        { !isValid && <FormHelperText>Please enter a valid value</FormHelperText>}
    </FormControl>)
}